// EmptyState — intentional, architecturally clear empty surface
// for lanes that exist in the shell but aren't populated yet.

import type { ReactNode } from 'react'

interface EmptyStateProps {
  title: string
  body?: ReactNode
}

export default function EmptyState({ title, body }: EmptyStateProps) {
  return (
    <div
      style={{
        border: '1px dashed rgba(255,255,255,0.14)',
        borderRadius: 18,
        padding: 24,
        background: 'rgba(255,255,255,0.025)',
      }}
    >
      <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 8, color: '#edf2ff' }}>{title}</div>
      {body && <div style={{ fontSize: 13, color: '#97a7cf', lineHeight: 1.6 }}>{body}</div>}
    </div>
  )
}
